export enum SystemActions {
  Database = 'database',
  ActiveUsers = 'activestk',
  KickUser = 'kickuser',
  KickAllUser = 'kickallusers',
}
